import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
	name: 'safeUrl',
	standalone: false,
})
export class SafeUrlPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(url: string): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}
}
